<template>
  <div>
    <StockEquipmentPage
      ref="page"
      :slug="slug"
      :stock-id="id"
      :equipments="equipments"
      :trim-equipments="trimEquipments"
      :stock-equipments="stockEquipments"
      :trim-equipment-route="trimEquipmentRoute"
    />
    <EquipmentBottomBar @save="save()" @cancel="cancel()" />
  </div>
</template>

<script>
import StockEquipmentPage from '@components/StockEquipmentPage.vue'
import EquipmentBottomBar from '@components/equipment/EquipmentBottomBar.vue'

export default {
  name: 'StockEquipment',
  components: {
    StockEquipmentPage,
    EquipmentBottomBar
  },
  props: {
    slug: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    equipments: {
      type: [Array, Object],
      default() {
        return {}
      }
    },
    stockEquipments: {
      type: [Array, Object],
      default() {
        return {}
      }
    },
    trimEquipments: {
      type: [Array, Object],
      default() {
        return {}
      }
    },
    trimEquipmentRoute: {
      type: String,
      default: ''
    }
  },
  methods: {
    save() {
      this.$refs.page.save().then(() => {
        document.getElementById('featuresBadge').innerHTML =
          this.$store.getters['stockEquipment/selectedEquipmentCount']
      })
    },
    cancel() {
      window.location.href = '/inventory' + '/stock' + '/' + this.slug
    },
    toggleSelectionView() {
      this.$refs.page.toggleSelectionView()
    }
  }
}
</script>
